const isAuthProtected = (page) => {
  page.isProtected = true
  return page
}

export default isAuthProtected
